<template>
  <b-card class="mt-2" body-bg-variant="light">
    <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
      <b-col xl="12">
        <h4>Geofencing condition has not been implemented yet.</h4>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {};
</script>

<style></style>
